module.exports = __webpack_public_path__ + "img/icon-03---Copy---Copy.7f2e13dd.png";